module.exports = __webpack_public_path__ + "static/google-material-3-ui-kit-web-plp-a45342d65704e2dd0ab9280afe8590f8.jpeg";